import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const catAlert = createAction(types.CAT_ALERT, (catAlert: any[]) => ({
    payload: catAlert,
}));
